import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

/**
 * Author Card widget (section 3003). Presentation only — the author it renders is
 * the one linked to the page, so nothing about the author is persisted here.
 */
export interface IAuthorCardPayload {
  id?: number | string;
  page_id?: number;
  component_id?: number;
  variant?: string;
  [key: string]: unknown;
}

export async function createAuthorCard(payload: IAuthorCardPayload) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.AUTHOR_CARD.CREATE,
      payload,
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateAuthorCard(
  id: number,
  payload: IAuthorCardPayload,
) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.AUTHOR_CARD.UPDATE(id),
      payload,
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
